export default function Footer() {
  return (
    <div className="h-[60px] flex bg-[#fff] sticky top-0 z-[1000]">
      <div className="w-full max-w-[1000px] h-full mx-auto flex items-center px-4 justify-between">
        <div className="w-[130px] flex-shrink-0">
          <img
            src="https://storage.googleapis.com/primesecure/sulamerica-logo.webp"
            className="w-auto h-auto my-auto"
            alt="Logo RM"
          />
        </div>
        <div className="text-sm text-gray-700">
          PRIME SECURE CORRETORA DE SEGUROS LTDA – 21.920.114/0001-20
        </div>
      </div>
    </div>
  );
}
